import { createContext, Dispatch, SetStateAction, useContext } from "react";

type TanstackDevToolsInProduction = [boolean, Dispatch<SetStateAction<boolean>>];

export const TanstackDevToolsInProductionContext = createContext<TanstackDevToolsInProduction | null>(null);

export function useTanstackDevToolsInProduction(): TanstackDevToolsInProduction {
    const ctx = useContext(TanstackDevToolsInProductionContext);
    if (!ctx) {
        throw new Error("useTanstackDevToolsInProduction must be used within provider");
    }
    return ctx;
}
